import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const ArcBankStatementError: FunctionComponent = () => {
  return (
    <Fragment>
      {/* <Text className="error-description">We are sorry</Text> */}
      <Text className="error-description">Something went wrong in the uploaded bank statement</Text>
      <Text className="error-description">Please ensure you upload a correct statement</Text>
    </Fragment>
  )
}

export default ArcBankStatementError;